import VueI18n from "vue-i18n";
import messages from "./lang/messages";

let lang = window.navigator.language;
//Cover all "en" settings so we don't get log spam if you are English (United States)
if (lang == "en-US") {
  lang = "en";
}

export default new VueI18n({
  locale: lang,
  fallbackLocale: "en",
  messages
});



// WEBPACK FOOTER //
// ./src/i18n/setup.js